import { useState } from "react"
import {ChevronDown} from 'lucide-react'

function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const faqs = [
    {
      question: "Это подойдет, если я не люблю планирование?",
      answer: "Планирование — это не хобби, а инструмент. Терпи, дисциплинируйся и зарабатывай.",
    },
    {
      question: "Я фрилансер, у меня хаос в проектах.",
      answer: "Планер разложит клиентов и деньги по полочкам. Ты перестанешь забывать о задачах.",
    },
    {
      question: "А если я не разберусь в Excel?",
      answer: "Там не нужно вводить формулы. Просто заполняй ячейки. Инструкция в подарок.",
    },
    {
      question: "Это разовая покупка?",
      answer: "Да. Доступ навсегда. Платишь 590₽ один раз.",
    },
  ]

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white fade-on-scroll opacity-0">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-black mb-12 sm:mb-16 uppercase">
          FAQ
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 sm:px-8 py-5 sm:py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors duration-200"
              >
                <span className="text-lg sm:text-xl font-bold text-black pr-4">
                  В: {faq.question}
                </span>
                <ChevronDown
                  className={`w-6 h-6 text-[#1E2B3C] flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              {openIndex === index ? (
                <div className="px-6 sm:px-8 pb-5 sm:pb-6">
                  <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
                    <strong className="text-[#F45B3C]">О:</strong> {faq.answer}
                  </p>
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
